import React, { useState } from 'react';
import { TagsSectionContainer, TagsContainer, AddTagsContainer } from '../ConfigPage.styled';
import { Button, TextField, Tag } from '@ann/web-components';

const TagsSection = ({ tags, onAddTag, onRemoveTag }) => {
    const [newTag, setNewTag] = useState('');

    const handleAdd = () => {
        if (newTag.trim()) {
            onAddTag(newTag.trim());
            setNewTag('');
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleAdd();
        }
    };

    return (
        <TagsSectionContainer>
            <AddTagsContainer>
                <TextField
                    label="Tags"
                    placeholder="Enter a tag"
                    value={newTag}
                    onChange={setNewTag}
                    onKeyPress={handleKeyPress}
                    size="small"
                />
                <Button
                    label="Add"
                    size="medium"
                    type="secondary"
                    icon="plus"
                    onClick={handleAdd}
                />
            </AddTagsContainer>

            <TagsContainer>
                {tags.map((tag, index) => (
                    <Tag
                        key={index}
                        closable
                        color="informative"
                        size="medium"
                        text={tag}
                        onClose={() => onRemoveTag(tag)}
                    />
                ))}
            </TagsContainer>
        </TagsSectionContainer>
    );
};

export default TagsSection;
